'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Option = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

exports["default"] = PicklistOption;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _context = require('../Picklist/context');

var _icon = require('./icon');

var _icon2 = _interopRequireDefault(_icon);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/* eslint-disable no-script-url, react/prop-types, jsx-a11y/anchor-is-valid */


function preventDefault(event) {
  event.preventDefault();
}

var Option = function (_Component) {
  _inherits(Option, _Component);

  function Option(props) {
    _classCallCheck(this, Option);

    var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

    _this.itemRef = _react2["default"].createRef();
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleHover = _this.handleHover.bind(_this);
    return _this;
  }

  _createClass(Option, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          disabled = _props.disabled,
          variant = _props.variant,
          name = _props.name,
          currentValueName = _props.currentValueName;
      var isHeader = variant === 'header';

      if (disabled || isHeader || typeof name !== 'string' || name === currentValueName) {
        return null;
      }

      return this.register();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props2 = this.props,
          currentValueName = _props2.currentValueName,
          name = _props2.name;
      var prevCurrentValueName = prevProps.currentValueName;

      if (prevCurrentValueName !== currentValueName) {
        if (prevCurrentValueName === name && currentValueName !== name) {
          this.register();
        } else if (prevCurrentValueName !== name && currentValueName === name) {
          this.unregister();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      return this.unregister();
    }
  }, {
    key: 'getHeaderClassNames',
    value: function getHeaderClassNames() {
      var className = this.props.className;
      return (0, _classnames2["default"])('rainbow-picklist-option_header', className);
    }
  }, {
    key: 'getItemClassNames',
    value: function getItemClassNames() {
      var _props3 = this.props,
          className = _props3.className,
          activeOptionName = _props3.activeOptionName,
          name = _props3.name,
          currentValueName = _props3.currentValueName;
      return (0, _classnames2["default"])('rainbow-picklist-option', {
        'rainbow-picklist-option_selected': currentValueName === name,
        'rainbow-picklist-option_active': activeOptionName === name
      }, className);
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      var _props4 = this.props,
          disabled = _props4.disabled,
          privateOnClick = _props4.privateOnClick,
          label = _props4.label,
          name = _props4.name,
          icon = _props4.icon,
          value = _props4.value;

      if (disabled) {
        event.preventDefault();
        return null;
      }

      return privateOnClick(event, {
        label: label,
        name: name,
        icon: icon,
        value: value
      });
    }
  }, {
    key: 'handleHover',
    value: function handleHover(event) {
      var _props5 = this.props,
          privateOnHover = _props5.privateOnHover,
          disabled = _props5.disabled,
          name = _props5.name;

      if (disabled) {
        return null;
      }

      return privateOnHover(event, name);
    }
  }, {
    key: 'register',
    value: function register() {
      var _this2 = this;

      var _props6 = this.props,
          privateRegisterChild = _props6.privateRegisterChild,
          label = _props6.label,
          name = _props6.name,
          icon = _props6.icon,
          value = _props6.value;
      return setTimeout(function () {
        return privateRegisterChild(_this2.itemRef.current, {
          label: label,
          name: name,
          icon: icon,
          value: value
        });
      }, 0);
    }
  }, {
    key: 'unregister',
    value: function unregister() {
      var _this3 = this;

      var privateUnregisterChild = this.props.privateUnregisterChild;
      return setTimeout(function () {
        return privateUnregisterChild(_this3.itemRef.current);
      }, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props7 = this.props,
          style = _props7.style,
          label = _props7.label,
          title = _props7.title,
          variant = _props7.variant,
          icon = _props7.icon,
          iconPosition = _props7.iconPosition,
          disabled = _props7.disabled;

      if (variant === 'header') {
        return _react2["default"].createElement('li', {
          className: this.getHeaderClassNames(),
          style: style,
          title: title,
          role: 'presentation',
          onMouseDown: preventDefault
        }, _react2["default"].createElement('span', {
          className: 'rainbow-picklist-option_header-label'
        }, label));
      }

      var hasLeftIcon = !!(icon && iconPosition === 'left');
      var hasRightIcon = !!(icon && iconPosition === 'right');
      return _react2["default"].createElement('li', {
        className: this.getItemClassNames(),
        style: style,
        role: 'presentation',
        onMouseDown: this.handleClick,
        onMouseEnter: this.handleHover
      }, _react2["default"].createElement('a', {
        href: 'javascript:void(0);',
        role: 'menuitem',
        'aria-disabled': disabled,
        ref: this.itemRef
      }, _react2["default"].createElement('span', {
        className: 'rainbow-picklist-option_icon-container',
        title: title
      }, _react2["default"].createElement(_icon2["default"], {
        'data-id': 'menu-item-left-icon',
        icon: icon,
        isVisible: hasLeftIcon,
        position: iconPosition
      }), label), _react2["default"].createElement(_icon2["default"], {
        'data-id': 'menu-item-right-icon',
        icon: icon,
        isVisible: hasRightIcon,
        position: iconPosition
      })));
    }
  }]);

  return Option;
}(_react.Component);
/**
 * Represents a list options in a menu.
 * @category Form
 */


function PicklistOption(props) {
  return _react2["default"].createElement(_context.Consumer, null, function (values) {
    return _react2["default"].createElement(Option, _extends({}, props, values));
  });
}

exports.Option = Option;
PicklistOption.propTypes = {
  /** Text of the PicklistOption. */
  label: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].node]).isRequired,

  /** The name of the PicklistOption. */
  name: _propTypes2["default"].string.isRequired,

  /** The variant changes the type of PicklistOption.
   * Accepted variants include default and header.
   * This value defaults to default. */
  variant: _propTypes2["default"].oneOf(['default', 'header']),

  /** The icon to show if it is passed. It must be a svg icon or a font icon. */
  icon: _propTypes2["default"].node,

  /** Describes the position of the icon with respect to body. Options include left and right.
   * This value defaults to left. */
  iconPosition: _propTypes2["default"].oneOf(['left', 'right']),

  /** If true the PicklistOption is not actionable and is shown as disabled. */
  disabled: _propTypes2["default"].bool,

  /** Displays tooltip text when the mouse moves over the element. */
  title: _propTypes2["default"].string,

  /** The value of the PicklistOption. */
  value: _propTypes2["default"].object,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes2["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes2["default"].object
};
PicklistOption.defaultProps = {
  name: undefined,
  variant: 'default',
  icon: null,
  iconPosition: 'left',
  disabled: false,
  title: undefined,
  className: undefined,
  style: undefined,
  value: undefined
};